export interface Video {
  id: number;
  title: string;
  cover: string;
  category: string;
  quality: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
}

export const allVideos: Video[] = [
  {
    id: 1,
    title: '星际征途：暗影纪元',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20epic%20movie%20poster%20style%20with%20dark%20space%20background%20nebula%20and%20a%20lone%20astronaut%20floating%20emitting%20golden%20energy%20light%20cinematic%20dramatic%20lighting%20ultra%20detailed%20realistic%208k%20quality&width=800&height=450&seq=video-cover-01&orientation=landscape',
    category: 'lanmei',
    quality: '蓝光4K',
    duration: '2:18:42',
    views: 1280000,
    rating: 9.2,
    description: '公元2147年，人类在遥远的星系发现了神秘的暗影能量。一支由精英宇航员组成的探险队踏上了探索未知的征程，却意外揭开了宇宙最深处的秘密。一场关乎人类命运的星际战争一触即发。',
    tags: ['科幻', '动作', '星际', '冒险'],
    releaseDate: '2026-07-15',
  },
  {
    id: 2,
    title: '夜幕追踪',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20noir%20thriller%20movie%20poster%20with%20rainy%20city%20street%20at%20night%20neon%20reflections%20on%20wet%20pavement%20a%20silhouetted%20detective%20figure%20mysterious%20atmosphere%20cinematic%20dramatic%20composition&width=800&height=450&seq=video-cover-02&orientation=landscape',
    category: 'tangxin',
    quality: '4K超清',
    duration: '1:52:18',
    views: 956000,
    rating: 8.9,
    description: '深夜的城市，霓虹灯下暗流涌动。一位退役特工被卷入了一场跨国阴谋，他必须在48小时内找到真相，否则整座城市将陷入危机。步步惊心的追踪与反追踪就此展开。',
    tags: ['悬疑', '动作', '犯罪', '追踪'],
    releaseDate: '2026-06-28',
  },
  {
    id: 3,
    title: '笑傲江湖之风云再起',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20movie%20poster%20with%20ancient%20Chinese%20landscape%20misty%20mountains%20two%20swordsmen%20dueling%20on%20a%20cliff%20edge%20golden%20sunset%20dramatic%20epic%20composition%20traditional%20ink%20painting%20style&width=800&height=450&seq=video-cover-03&orientation=landscape',
    category: 'heitao',
    quality: '蓝光4K',
    duration: '2:05:33',
    views: 2100000,
    rating: 9.5,
    description: '江湖风云变幻，英雄豪杰辈出。一位身世成谜的少年踏上了寻找真相的旅程，在刀光剑影中成长，在恩怨情仇中抉择，最终谱写了一曲荡气回肠的江湖传奇。',
    tags: ['武侠', '动作', '古装', '江湖'],
    releaseDate: '2026-07-08',
  },
  {
    id: 4,
    title: '甜蜜邂逅',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20movie%20poster%20warm%20sunset%20park%20scene%20couple%20sitting%20on%20bench%20cherry%20blossom%20trees%20soft%20golden%20lighting%20dreamy%20bokeh%20effect%20emotional%20tender%20atmosphere&width=800&height=450&seq=video-cover-04&orientation=landscape',
    category: 'yaojing',
    quality: '4K超清',
    duration: '1:45:20',
    views: 1870000,
    rating: 9.0,
    description: '两个性格迥异的年轻人在一次偶然的旅途中相遇，从互相嫌弃到彼此欣赏，一段甜美的爱情故事在不经意间悄然绽放。这是一部让人嘴角上扬的浪漫喜剧。',
    tags: ['爱情', '喜剧', '浪漫', '青春'],
    releaseDate: '2026-06-15',
  },
  {
    id: 5,
    title: '极限追击：东京任务',
    cover: 'https://readdy.ai/api/search-image?query=High-octane%20action%20thriller%20movie%20poster%20Tokyo%20cityscape%20at%20night%20fast%20sports%20car%20drifting%20neon%20signs%20blazing%20speed%20motion%20blur%20intense%20dramatic%20lighting%20adrenaline%20rush&width=800&height=450&seq=video-cover-05&orientation=landscape',
    category: 'lanmei',
    quality: '蓝光4K',
    duration: '1:58:45',
    views: 1650000,
    rating: 8.8,
    description: '东京街头，一场惊心动魄的追车大战正在上演。国际刑警与黑帮势力之间的较量，速度与激情的完美碰撞，每一秒都让人屏息凝神。',
    tags: ['动作', '犯罪', '追车', '东京'],
    releaseDate: '2026-07-01',
  },
  {
    id: 6,
    title: '深海迷踪',
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20thriller%20movie%20poster%20deep%20ocean%20abyss%20mysterious%20ancient%20ruins%20bioluminescent%20creatures%20divers%20exploring%20dark%20blue%20depths%20eerie%20atmosphere%20cinematic%20composition&width=800&height=450&seq=video-cover-06&orientation=landscape',
    category: 'tangxin',
    quality: '蓝光4K',
    duration: '2:12:08',
    views: 892000,
    rating: 8.7,
    description: '一支深海探险队在太平洋深处发现了一座失落的文明遗迹。然而，他们很快发现这座遗迹并非空无一人，某种神秘的存在正在暗中注视着他们的一举一动。',
    tags: ['科幻', '悬疑', '深海', '探险'],
    releaseDate: '2026-06-20',
  },
  {
    id: 7,
    title: '厨神争霸',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cooking%20competition%20movie%20poster%20elaborate%20banquet%20table%20gourmet%20dishes%20steam%20rising%20dramatic%20kitchen%20lighting%20chef%20in%20action%20fiery%20wok%20artistic%20food%20photography%20warm%20atmosphere&width=800&height=450&seq=video-cover-07&orientation=landscape',
    category: 'heitao',
    quality: '4K超清',
    duration: '1:38:55',
    views: 750000,
    rating: 9.1,
    description: '全国各地顶级厨师齐聚一堂，展开一场色香味俱全的美食对决。刀光勺影之间，不仅是厨艺的比拼，更是对美食文化的传承与创新。',
    tags: ['美食', '喜剧', '竞技', '文化'],
    releaseDate: '2026-05-28',
  },
  {
    id: 8,
    title: '荒野求生：极地生存',
    cover: 'https://readdy.ai/api/search-image?query=Survival%20documentary%20movie%20poster%20arctic%20wilderness%20snow%20covered%20mountains%20lone%20figure%20trekking%20through%20blizzard%20northern%20lights%20aurora%20in%20sky%20dramatic%20harsh%20environment%20epic%20scale&width=800&height=450&seq=video-cover-08&orientation=landscape',
    category: 'yaojing',
    quality: '蓝光4K',
    duration: '1:55:30',
    views: 1080000,
    rating: 9.3,
    description: '跟随探险家的脚步，深入北极圈最严酷的地带。在零下50度的极端环境中，见证人类意志与大自然力量之间的终极较量。',
    tags: ['纪录', '探险', '极地', '生存'],
    releaseDate: '2026-07-12',
  },
  {
    id: 9,
    title: '时空裂缝',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20time%20travel%20movie%20poster%20swirling%20time%20portal%20vortex%20clock%20mechanisms%20floating%20in%20space%20surreal%20dimension%20bending%20reality%20visual%20effects%20cinematic%20spectacular%20golden%20energy%20rings&width=800&height=450&seq=video-cover-09&orientation=landscape',
    category: 'dongzuo',
    quality: '蓝光4K',
    duration: '2:25:10',
    views: 2300000,
    rating: 9.4,
    description: '一位物理学家意外打开了时空裂缝，发现自己可以穿梭于不同的时间线。然而每一次穿越都在改变现实的根基，他必须在拯救爱人和维护时空稳定之间做出艰难抉择。',
    tags: ['科幻', '动作', '时空', '穿越'],
    releaseDate: '2026-07-20',
  },
  {
    id: 10,
    title: '人间烟火',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20film%20poster%20traditional%20hutong%20alleyway%20warm%20evening%20lanterns%20family%20gathering%20around%20dinner%20table%20steam%20rising%20from%20hotpot%20nostalgic%20intimate%20atmosphere%20documentary%20style%20realism&width=800&height=450&seq=video-cover-10&orientation=landscape',
    category: 'juqing',
    quality: '4K超清',
    duration: '2:08:15',
    views: 1450000,
    rating: 9.6,
    description: '在北京一条老胡同里，四代同堂的大家庭面临着城市改造的冲击。在传统与现代的碰撞中，每个人都在寻找属于自己的位置。这是一部关于家、关于根、关于爱的温暖故事。',
    tags: ['剧情', '家庭', '温情', '北京'],
    releaseDate: '2026-06-10',
  },
  {
    id: 11,
    title: '欢乐喜剧人之巅峰对决',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20show%20poster%20bright%20theater%20stage%20spotlight%20colorful%20confetti%20falling%20comedians%20performing%20hilarious%20expressions%20audience%20laughing%20joyful%20festive%20atmosphere%20vibrant%20energetic&width=800&height=450&seq=video-cover-11&orientation=landscape',
    category: 'xiju',
    quality: '4K超清',
    duration: '1:32:40',
    views: 3200000,
    rating: 9.3,
    description: '国内顶尖喜剧人齐聚一堂，展开一场笑料百出的才艺大比拼。相声、小品、脱口秀轮番上阵，包袱不断，笑声不停。',
    tags: ['喜剧', '综艺', '搞笑', '相声'],
    releaseDate: '2026-07-05',
  },
  {
    id: 12,
    title: '午夜凶铃：重生',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20horror%20thriller%20movie%20poster%20abandoned%20house%20in%20foggy%20forest%20pale%20moonlight%20old%20television%20set%20static%20snow%20eerie%20atmosphere%20dark%20shadows%20psychological%20terror%20chilling%20composition&width=800&height=450&seq=video-cover-12&orientation=landscape',
    category: 'kongbu',
    quality: '蓝光4K',
    duration: '1:48:30',
    views: 1890000,
    rating: 8.6,
    description: '一段被遗忘的恐怖传说在现代都市中重新浮现。一群年轻人无意中触发了古老的诅咒，七天倒计时已经开始，没有人知道下一个会是谁。',
    tags: ['恐怖', '悬疑', '惊悚', '诅咒'],
    releaseDate: '2026-07-18',
  },
  {
    id: 13,
    title: '北京遇上西雅图3',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20couple%20walking%20through%20autumn%20park%20golden%20leaves%20falling%20Seattle%20skyline%20in%20background%20Space%20Needle%20visible%20warm%20sunset%20lighting%20emotional%20tender%20moment%20cinematic&width=800&height=450&seq=video-cover-13&orientation=landscape',
    category: 'aiqing',
    quality: '4K超清',
    duration: '2:02:18',
    views: 2600000,
    rating: 9.1,
    description: '跨越太平洋的爱情故事再度续写。两个来自不同文化背景的人在异国他乡相遇、相知、相爱，面对现实的重重考验，他们能否坚守初心？',
    tags: ['爱情', '剧情', '跨国', '温情'],
    releaseDate: '2026-07-22',
  },
  {
    id: 14,
    title: '银河护卫队：新纪元',
    cover: 'https://readdy.ai/api/search-image?query=Space%20opera%20sci-fi%20movie%20poster%20colorful%20alien%20planet%20landscape%20bizarre%20creatures%20spaceship%20fleet%20flying%20through%20colorful%20nebula%20vibrant%20cosmic%20colors%20epic%20adventure%20scale%20cinematic&width=800&height=450&seq=video-cover-14&orientation=landscape',
    category: 'kehuan',
    quality: '蓝光4K',
    duration: '2:30:00',
    views: 4500000,
    rating: 9.0,
    description: '银河系面临着前所未有的威胁，一支由各星球英雄组成的护卫队集结出发。在浩瀚的宇宙中，他们将经历怎样的冒险与挑战？',
    tags: ['科幻', '冒险', '宇宙', '英雄'],
    releaseDate: '2026-08-01',
  },
  {
    id: 15,
    title: '地球脉动：海洋深处',
    cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20deep%20ocean%20scene%20whale%20shark%20swimming%20through%20coral%20reef%20sunrays%20penetrating%20water%20surface%20colorful%20tropical%20fish%20amazing%20marine%20life%20majestic%20peaceful&width=800&height=450&seq=video-cover-15&orientation=landscape',
    category: 'jilu',
    quality: '蓝光4K',
    duration: '2:45:00',
    views: 1800000,
    rating: 9.8,
    description: '深入海洋最隐秘的角落，探索地球上最后一片未被完全探索的疆域。从珊瑚礁到深海海沟，从极地冰层到热带海域，每一帧都是大自然的惊世杰作。',
    tags: ['纪录', '自然', '海洋', '探索'],
    releaseDate: '2026-07-25',
  },
  {
    id: 16,
    title: '功夫之巅',
    cover: 'https://readdy.ai/api/search-image?query=Martial%20arts%20action%20movie%20poster%20ancient%20Chinese%20temple%20on%20mountain%20peak%20master%20and%20student%20training%20at%20dawn%20golden%20morning%20light%20fog%20swirling%20around%20dynamic%20kungfu%20poses%20epic%20cinematography&width=800&height=450&seq=video-cover-16&orientation=landscape',
    category: 'dongzuo',
    quality: '蓝光4K',
    duration: '2:10:05',
    views: 1700000,
    rating: 9.2,
    description: '深山古刹中，一位武学宗师将毕生所学倾囊相授。年轻的弟子在刻苦修炼中领悟了功夫的真谛——不在于招式，而在于内心的修行。',
    tags: ['动作', '武侠', '功夫', '修行'],
    releaseDate: '2026-07-10',
  },
  {
    id: 17,
    title: '无声的证人',
    cover: 'https://readdy.ai/api/search-image?query=Courtroom%20legal%20drama%20movie%20poster%20dramatic%20courtroom%20scene%20judge%20bench%20lawyer%20arguing%20passionately%20warm%20wooden%20interior%20dramatic%20lighting%20from%20windows%20tension%20atmosphere%20serious%20expressions&width=800&height=450&seq=video-cover-17&orientation=landscape',
    category: 'juqing',
    quality: '4K超清',
    duration: '2:15:40',
    views: 980000,
    rating: 9.0,
    description: '一起看似简单的案件背后，隐藏着深不可测的阴谋。一位年轻律师凭借一个被忽视的细节，一步步揭开了真相的面纱。正义也许会迟到，但永远不会缺席。',
    tags: ['剧情', '法律', '悬疑', '正义'],
    releaseDate: '2026-06-25',
  },
  {
    id: 18,
    title: '疯狂动物城2',
    cover: 'https://readdy.ai/api/search-image?query=Animated%20comedy%20movie%20poster%20vibrant%20animal%20city%20skyscrapers%20diverse%20animal%20characters%20bunny%20and%20fox%20detectives%20colorful%20lively%20bustling%20metropolis%20joyful%20adventurous%20family%20friendly&width=800&height=450&seq=video-cover-18&orientation=landscape',
    category: 'xiju',
    quality: '蓝光4K',
    duration: '1:48:22',
    views: 5100000,
    rating: 9.5,
    description: '动物城迎来了新的挑战，兔子警官和狐狸搭档再次联手破案。这次他们发现了一个足以颠覆整个动物城秩序的巨大阴谋。',
    tags: ['动画', '喜剧', '冒险', '动物'],
    releaseDate: '2026-07-30',
  },
  {
    id: 19,
    title: '暗夜猎手',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20foggy%20forest%20at%20night%20silhouette%20of%20hunter%20with%20crossbow%20moonlight%20filtering%20through%20trees%20tense%20atmosphere%20deer%20in%20clearing%20dramatic%20shadows%20muted%20colors%20suspense&width=800&height=450&seq=video-cover-19&orientation=landscape',
    category: 'kongbu',
    quality: '4K超清',
    duration: '1:55:12',
    views: 760000,
    rating: 8.5,
    description: '在一个偏远的小镇上，连续发生的离奇失踪案件引起了FBI的注意。一位资深侧写师深入调查，发现自己面对的是一位智商极高的连环杀手。',
    tags: ['惊悚', '犯罪', '心理', '追踪'],
    releaseDate: '2026-07-03',
  },
  {
    id: 20,
    title: '梦境建筑师',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20sci-fi%20movie%20poster%20surreal%20dreamscape%20floating%20islands%20impossible%20architecture%20staircases%20leading%20to%20sky%20water%20flowing%20upwards%20vibrant%20magical%20colors%20ethereal%20lighting%20mind%20bending%20visual&width=800&height=450&seq=video-cover-20&orientation=landscape',
    category: 'kehuan',
    quality: '蓝光4K',
    duration: '2:20:38',
    views: 1950000,
    rating: 9.4,
    description: '在未来世界，人们可以通过科技进入他人的梦境。一位天才梦境建筑师接受了一项前所未有的挑战——在梦境的深层植入一个改变现实的想法。',
    tags: ['科幻', '奇幻', '梦境', '悬疑'],
    releaseDate: '2026-07-28',
  },
  {
    id: 21,
    title: '舌尖上的年味',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20food%20documentary%20poster%20family%20reunion%20dinner%20table%20filled%20with%20traditional%20dishes%20steam%20rising%20red%20lanterns%20hanging%20warm%20festive%20atmosphere%20close%20up%20delicious%20food%20vibrant%20colors&width=800&height=450&seq=video-cover-21&orientation=landscape',
    category: 'jilu',
    quality: '4K超清',
    duration: '1:30:00',
    views: 2200000,
    rating: 9.6,
    description: '从北到南，从东到西，走遍中国大江南北，记录各地春节年俗和年夜饭的独特魅力。每一道菜背后，都是一个个关于家与团圆的故事。',
    tags: ['纪录', '美食', '春节', '文化'],
    releaseDate: '2026-01-25',
  },
  {
    id: 22,
    title: '蔷薇花开时',
    cover: 'https://readdy.ai/api/search-image?query=Youth%20romance%20movie%20poster%20blooming%20rose%20garden%20springtime%20young%20couple%20holding%20hands%20walking%20through%20flower%20path%20soft%20sunset%20light%20petals%20floating%20in%20air%20dreamy%20nostalgic%20atmosphere%20warm&width=800&height=450&seq=video-cover-22&orientation=landscape',
    category: 'aiqing',
    quality: '蓝光4K',
    duration: '1:50:15',
    views: 1350000,
    rating: 8.9,
    description: '高中时代，蔷薇花开的季节，一段青涩的初恋在校园的角落里悄然绽放。多年后回望，青春虽然远去，但那份纯真的感情依然温暖如初。',
    tags: ['爱情', '青春', '校园', '回忆'],
    releaseDate: '2026-05-20',
  },
  {
    id: 23,
    title: '飓风营救：怒火街头',
    cover: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20city%20street%20destroyed%20by%20disaster%20helicopter%20flying%20low%20explosions%20smoke%20debris%20hero%20running%20through%20chaos%20intense%20dramatic%20orange%20fire%20lighting%20adrenaline&width=800&height=450&seq=video-cover-23&orientation=landscape',
    category: 'dongzuo',
    quality: '蓝光4K',
    duration: '2:05:30',
    views: 3100000,
    rating: 8.8,
    description: '一场突如其来的飓风席卷了沿海城市，在混乱中，一伙武装分子趁乱劫持了市政府大楼。一位休假中的特种兵临危受命，独自深入险境解救人质。',
    tags: ['动作', '灾难', '营救', '刺激'],
    releaseDate: '2026-07-14',
  },
  {
    id: 24,
    title: '未来水世界',
    cover: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20sci-fi%20movie%20poster%20endless%20ocean%20horizon%20floating%20city%20made%20of%20scrap%20materials%20dramatic%20storm%20clouds%20sunset%20on%20water%20lone%20sailboat%20epic%20scale%20desolate%20atmospheric&width=800&height=450&seq=video-cover-24&orientation=landscape',
    category: 'kehuan',
    quality: '蓝光4K',
    duration: '2:35:20',
    views: 1600000,
    rating: 8.7,
    description: '全球变暖导致海平面上升，陆地被彻底淹没。幸存的人类在漂浮的城市中艰难求生，而传说中的最后一片陆地，成为了所有人追寻的希望。',
    tags: ['科幻', '灾难', '海洋', '生存'],
    releaseDate: '2026-06-18',
  },
];